(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      const slides = [...root.querySelectorAll('.mauja-hero__slide')];
      const dots = [...root.querySelectorAll('.mauja-hero__dot')];
      let i = 0;
      let timer = null;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = parseInt(root.dataset.speed, 10) || 6000;
      const auto = root.dataset.autoplay === 'true' && !reduce;

      /* Videos ship with preload="none" so nothing downloads up front. The
         slide that is showing gets loaded and played, the rest stay idle. */
      const playSlideVideo = (slide, on) => {
        const v = slide.querySelector('video');
        if (!v) return;
        if (on) {
          v.muted = true;
          if (v.preload !== 'auto') v.preload = 'auto';
          const go = () => v.play().catch(() => {});
          if (v.readyState >= 2) go();
          else { v.load(); v.addEventListener('canplay', go, { once: true }); }
        } else {
          v.pause();
        }
      };

      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => {
          const on = k === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          playSlideVideo(s, on);
        });
        dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      };
      const start = () => { if (auto && slides.length > 1) { stop(); timer = setInterval(() => go(i + 1), speed); } };
      const stop = () => { if (timer) clearInterval(timer); timer = null; };

      root.querySelectorAll('.mauja-hero__arrow').forEach((b) =>
        b.addEventListener('click', () => { go(i + parseInt(b.dataset.dir, 10)); start(); })
      );
      dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.go, 10)); start(); }));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      let x0 = null;
      root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); }
        x0 = null;
      });

      document.addEventListener('shopify:block:select', (e) => {
        const s = slides.find((el) => (el.getAttribute('data-shopify-editor-block') || '').includes(e.detail.blockId));
        if (s) { stop(); go(parseInt(s.dataset.index, 10)); }
      });

      /* Nothing rotates or streams while the hero is off screen */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { playSlideVideo(slides[i], true); start(); }
            else { stop(); slides.forEach((s) => playSlideVideo(s, false)); }
          });
        }, { threshold: 0.15 }).observe(root);
      }

      go(0);
      start();
    };
    const boot = () => document.querySelectorAll('.mauja-hero').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const els = () => document.querySelectorAll('[data-mnl]');
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      els().forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.9)));
        el.style.setProperty('--mnl-scale', (1.3 - 0.3 * p).toFixed(4));
      });
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-notify"]) return;
  try {
    
  (() => {
    const start = () => {
      const box = document.getElementById('MaujaNotify');
      const dataEl = document.getElementById('MaujaNotifyData');
      if (!box || !dataEl || box.dataset.ready) return;
      box.dataset.ready = '1';
      let items = [];
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!items.length) return;
      const KEY = 'mauja_notify_v1';
      let st = { n: 0, off: false, seen: [] };
      try { st = Object.assign(st, JSON.parse(sessionStorage.getItem(KEY) || '{}')); } catch (e) {}
      const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
      const max = parseInt(box.dataset.max, 10) || 3;
      if (st.off || st.n >= max) return;
      const low = items.filter((i) => i.k === 'low');
      const fresh = items.filter((i) => i.k === 'new').sort(() => Math.random() - 0.5);
      let queue = [...low, ...fresh].filter((i) => !st.seen.includes(i.u));
      if (!queue.length) return;
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const busy = () => document.querySelector('.mp.is-open, dialog[open], details[open].menu-drawer, .cart-drawer[open]') || document.hidden;
      let timer;
      const show = () => {
        if (st.off || st.n >= max || !queue.length) return;
        if (busy()) { timer = setTimeout(show, 5000); return; }
        const it = queue.shift();
        const isLow = it.k === 'low';
        const label = isLow ? box.dataset.low : box.dataset.new;
        const colour = it.c ? ' in ' + esc(it.c.toLowerCase()) : '';
        const text = isLow
          ? '<strong>' + esc(it.n) + '</strong>' + colour + ' ' + esc(box.dataset.lowText)
          : '<strong>' + esc(it.n) + '</strong>' + colour;
        const el = document.createElement('div');
        el.className = 'mnt__toast';
        el.innerHTML =
          '<a class="mnt__link" href="' + esc(it.u) + '" aria-label="' + esc(label + ': ' + it.n) + '"></a>' +
          '<span class="mnt__img">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" width="52" height="65" loading="lazy">' : '') + '</span>' +
          '<span><p class="mnt__label">' + esc(label) + '</p><p class="mnt__text">' + text + '</p><span class="mnt__cta">View</span></span>' +
          '<button type="button" class="mnt__x" aria-label="Dismiss notifications">' + (document.querySelector('#MaujaNotifyClose')?.innerHTML || '×') + '</button>';
        box.replaceChildren(el);
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
        st.n += 1; st.seen.push(it.u); save();
        const hide = () => { el.classList.remove('is-in'); setTimeout(() => el.remove(), 450); };
        let hideT = setTimeout(hide, 6500);
        el.addEventListener('mouseenter', () => clearTimeout(hideT));
        el.addEventListener('mouseleave', () => { hideT = setTimeout(hide, 2500); });
        el.querySelector('.mnt__x').addEventListener('click', () => { st.off = true; save(); clearTimeout(timer); hide(); });
        if (st.n < max && queue.length) timer = setTimeout(show, parseInt(box.dataset.gap, 10) || 30000);
      };
      const first = st.n > 0 ? (parseInt(box.dataset.gap, 10) || 30000) : (parseInt(box.dataset.first, 10) || 15000);
      timer = setTimeout(show, first);
    };
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
    if (document.readyState === 'complete') idle(start); else window.addEventListener('load', () => idle(start));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-popup"]) return;
  try {
    
  if (!customElements.get('mauja-dice')) {
    customElements.define('mauja-dice', class extends HTMLElement {
      connectedCallback() {
        this.key = 'mauja_dice_v1';
        this.WAIT = 5;
        this.die = this.querySelector('[data-die]');
        this.fab = document.querySelector('[data-md-fab]');
        this.face(6);
        this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', (e) => {
          if (el.tagName === 'A') { this.close(true); return; }
          e.preventDefault(); this.close(true);
        }));
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(true); });
        this.querySelector('[data-roll]').addEventListener('click', () => this.firstRoll());
        this.querySelector('[data-step="email"]').addEventListener('submit', (e) => { e.preventDefault(); this.takeEmail(); });
        this.querySelector('[data-ship]').addEventListener('submit', (e) => { e.preventDefault(); this.takeShip(); });
        this.querySelector('[data-copy-ship]').addEventListener('click', () => {
          navigator.clipboard?.writeText('SHIPFIRST').then(() => { this.querySelector('[data-copy-ship-label]').textContent = 'Copied'; }).catch(() => {});
        });
        this.querySelector('[data-copy]').addEventListener('click', (e) => {
          const code = this.querySelector('[data-code]').textContent;
          navigator.clipboard?.writeText(code).then(() => { this.querySelector('[data-copy-label]').textContent = 'Copied'; }).catch(() => {});
        });
        document.addEventListener('click', (e) => {
          const a = e.target.closest('a[href$="#join"], a[href$="#roll"], [data-md-fab]');
          if (a) { e.preventDefault(); this.reopen(); }
        });
        if (this.dataset.editor === 'true') { this.open(); return; }
        this.returning = this.dataset.returning === 'true';
        this.syncFab();
        const st = this.read();
        if (st && st.v === 'won' && st.code) { this.showCode(st.code, st.amount, st.email); return; }
        if (st && st.v === 'played' && this.waitDays() > 0) {
          this.cooldown();
          /* Missed but never claimed the free shipping: show the claim screen once per visit */
          if (!this.returning && !this.shipTaken() && !this.promptedThisVisit()) {
            this.markPrompted();
            setTimeout(() => { if (this.hidden) this.open(); }, 1500);
          }
          return;
        }
        if (st && st.v === 'closed' && Date.now() - st.t < (parseInt(this.dataset.days, 10) || 7) * 864e5) return;
        this.arm();
      }
      promptedThisVisit() { try { return sessionStorage.getItem('mauja_dice_prompt') === '1'; } catch (e) { return false; } }
      markPrompted() { try { sessionStorage.setItem('mauja_dice_prompt', '1'); } catch (e) {} }
      /* Reopen from the floating button, ticker or bell: always show the right screen for this visitor */
      reopen() {
        const st = this.read();
        if (st && st.v === 'won' && st.code) { this.showCode(st.code, st.amount, st.email); }
        else if (st && st.v === 'played' && this.waitDays() > 0) { this.cooldown(); }
        else { this.step('roll'); this.querySelector('[data-step="intro"]').hidden = false; const b = this.querySelector('[data-roll]'); b.disabled = false; }
        this.open();
      }
      /* The floating button: shown whenever there is something to come back for */
      syncFab() {
        if (!this.fab) return;
        const st = this.read();
        let label = '';
        if (st && st.v === 'won' && st.code) label = 'Your ' + (st.amount || 200) + ' EGP code';
        else if (st && st.v === 'played' && this.waitDays() > 0) label = (!this.returning && !this.shipTaken()) ? 'Claim free shipping' : (this.shipTaken() ? 'Your free shipping code' : '');
        else label = 'Roll the dice';
        this.fab.hidden = !label;
        const l = this.fab.querySelector('[data-md-fab-label]'); if (l && label) l.textContent = label;
      }
      /* Days left before the next roll (one roll every 5 days until you win) */
      waitDays() { const st = this.read(); if (!st || st.v !== 'played') return 0; return Math.max(0, Math.ceil((st.t + this.WAIT * 864e5 - Date.now()) / 864e5)); }
      cooldown() {
        const d = this.waitDays();
        const days = d + (d === 1 ? ' day' : ' days');
        const canShip = !this.returning && !this.shipTaken();
        this.querySelector('[data-ship]').hidden = !canShip;
        this.querySelector('[data-ship-done]').hidden = !this.shipTaken();
        this.querySelector('[data-lose-title]').textContent = canShip ? 'Free shipping is still yours' : (this.shipTaken() ? 'Your free shipping code' : 'Next roll in ' + days);
        this.querySelector('[data-lose-text]').textContent = canShip ? '' : (this.shipTaken() ? 'Your next roll for 200 EGP off is in ' + days + '.' : 'You only need one 6. Come back and roll again.');
        this.querySelector('[data-stake]').textContent = 'Next roll in ' + days;
        this.step('lose');
      }
      shipTaken() { try { return localStorage.getItem('mauja_dice_ship') === '1'; } catch (e) { return false; } }
      read() { try { return JSON.parse(localStorage.getItem(this.key) || 'null'); } catch (e) { return null; } }
      store(o) { try { localStorage.setItem(this.key, JSON.stringify(Object.assign({ t: Date.now() }, o))); } catch (e) {} this.syncFab(); }
      rand6() { const a = new Uint32Array(1); let x; do { crypto.getRandomValues(a); x = a[0]; } while (x >= 4294967292); return (x % 6) + 1; }
      face(n) {
        const map = { 1: [4], 2: [0, 8], 3: [0, 4, 8], 4: [0, 2, 6, 8], 5: [0, 2, 4, 6, 8], 6: [0, 2, 3, 5, 6, 8] };
        this.die.dataset.face = n;
        this.die.querySelectorAll('.md__pip').forEach((p, i) => { p.style.opacity = map[n].includes(i) ? '1' : '0'; });
        this.die.setAttribute('aria-label', 'Die shows ' + n);
      }
      step(name) { this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== name; }); }
      roll() {
        return new Promise((resolve) => {
          const result = this.rand6();
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.die.classList.remove('is-landed'); this.die.classList.add('is-rolling');
          let n = 0; const total = reduce ? 1 : 14;
          const tick = () => {
            n++;
            if (n < total) { let f; do { f = this.rand6(); } while (f === Number(this.die.dataset.face)); this.face(f); setTimeout(tick, 60 + n * 8); return; }
            this.face(result); this.die.classList.remove('is-rolling'); void this.die.offsetWidth; this.die.classList.add('is-landed');
            setTimeout(() => resolve(result), 380);
          };
          tick();
        });
      }
      async firstRoll() {
        const btn = this.querySelector('[data-roll]'); btn.disabled = true;
        this.store({ v: 'played' });
        this.markPrompted();
        const r = await this.roll();
        if (r === 6) { this.step('email'); setTimeout(() => this.querySelector('#MdEmail')?.focus({ preventScroll: true }), 50); }
        else {
          const ship = !this.returning && !this.shipTaken();
          this.lose(ship ? 'You rolled a ' + r + '. You still win!' : 'You rolled a ' + r + '.', ship ? '' : 'No 6 this time. Roll again in ' + this.WAIT + ' days, you only need one 6.', ship);
        }
      }
      takeEmail() {
        const input = this.querySelector('#MdEmail'); const err = this.querySelector('[data-email-error]');
        const v = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.hidden = false; input.focus(); return; }
        err.hidden = true; this.email = v;
        this.finish(200);
      }
      takeShip() {
        const input = this.querySelector('#MdShipEmail'); const err = this.querySelector('[data-ship-error]');
        const v = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.hidden = false; input.focus(); return; }
        err.hidden = true; this.email = v; this.closedSignup = true;
        try { localStorage.setItem('mauja_dice_ship', '1'); } catch (e) {}
        this.querySelector('[data-ship]').hidden = true;
        this.querySelector('[data-ship-done]').hidden = false;
        this.querySelector('[data-lose-title]').textContent = 'Free shipping is yours';
        this.querySelector('[data-lose-text]').textContent = 'Roll again in ' + Math.max(1, this.waitDays()) + ' days for a shot at 200 EGP off.';
        this.syncFab();
        this.signup(['newsletter', 'dice-ship']);
        try { window.fbq && window.fbq('track', 'Lead', { content_name: 'Dice game free shipping', currency: 'EGP', value: 0 }); } catch (e) {}
      }
      lose(title, text, ship) {
        this.querySelector('[data-ship]').hidden = !ship;
        this.querySelector('[data-ship-done]').hidden = true;
        this.querySelector('[data-lose-title]').textContent = title;
        this.querySelector('[data-lose-text]').textContent = text;
        this.querySelector('[data-stake]').textContent = ship ? 'You won free shipping' : 'Better luck next time';
        this.step('lose');
      }
      makeCode(amount) {
        const abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; const a = new Uint32Array(8); crypto.getRandomValues(a);
        let s = ''; for (const x of a) s += abc[x % abc.length];
        return 'ROLL' + amount + '-' + s;
      }
      async finish(amount) {
        const code = this.makeCode(amount);
        this.store({ v: 'won', code, amount, email: this.email });
        this.showCode(code, amount, this.email);
        await this.signup(['newsletter', 'dice-' + amount, 'dicecode-' + code]);
        try { window.fbq && window.fbq('track', 'Lead', { content_name: 'Dice game ' + amount, currency: 'EGP', value: 0 }); } catch (e) {}
      }
      showCode(code, amount, email) {
        this.querySelector('[data-code]').textContent = code;
        this.querySelector('[data-email]').textContent = email || 'your email';
        this.querySelector('[data-code-title]').textContent = amount + ' EGP off is yours';
        this.querySelector('[data-stake]').textContent = 'You won ' + amount + ' EGP';
        this.face(6);
        this.step('code');
        if (this.hidden && this.read() && this.read().shown !== true) {
          /* came back after a full-page fallback: show the code once more */
          const st = this.read(); st.shown = true; try { localStorage.setItem(this.key, JSON.stringify(st)); } catch (e) {}
          this.open();
        }
      }
      async signup(tags) {
        if (!this.email) return;
        const body = new URLSearchParams();
        body.set('form_type', 'customer'); body.set('utf8', '✓');
        body.set('contact[email]', this.email); body.set('contact[tags]', tags.join(','));
        body.set('contact[accepts_marketing]', 'true');
        try {
          const r = await fetch('/contact#mauja-dice', { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (r.url && /challenge/.test(r.url)) {
            /* Shopify asked for a captcha: fall back to a normal form post so the sign-up still goes through */
            const f = document.createElement('form'); f.method = 'post'; f.action = '/contact#mauja-dice'; f.hidden = true;
            for (const [k, v] of body) { const i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = v; f.appendChild(i); }
            document.body.appendChild(f); f.submit();
          }
        } catch (e) {}
      }
      arm() {
        let fired = false;
        const fire = () => { if (fired) return; fired = true; cleanup(); this.markPrompted(); this.open(); };
        /* Opens about 1.5 seconds into the visit (earlier if they scroll or move to leave) */
        const delay = 1500;
        let start = 0;
        try { start = parseInt(sessionStorage.getItem('mj_popup_start'), 10) || 0; if (!start) { start = Date.now(); sessionStorage.setItem('mj_popup_start', String(start)); } } catch (e) { start = Date.now(); }
        const timer = setTimeout(fire, Math.max(600, delay - (Date.now() - start)));
        const pct = parseInt(this.dataset.scroll, 10) || 0;
        const onScroll = () => { const h = document.documentElement; if (pct && (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) * 100 >= pct) fire(); };
        const onLeave = (e) => { if (e.clientY <= 0) fire(); };
        const cleanup = () => { clearTimeout(timer); document.removeEventListener('scroll', onScroll, { capture: true }); document.removeEventListener('mouseout', onLeave); };
        if (pct) document.addEventListener('scroll', onScroll, { capture: true, passive: true });
        if (this.dataset.exit === 'true' && matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
      }
      open() {
        this.lastFocus = document.activeElement; this.hidden = false;
        if (this.fab) this.fab.hidden = true;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => { this.classList.add('is-open'); });
      }
      close(remember) {
        if (this.hidden) return;
        this.classList.remove('is-open'); document.documentElement.style.overflow = '';
        const st = this.read();
        if (remember && (!st || st.v === 'closed')) this.store({ v: 'closed' });
        if (this.email && st && st.v === 'played' && !this.closedSignup) { this.closedSignup = true; this.signup(['newsletter', 'dice-left']); }
        setTimeout(() => { this.hidden = true; this.syncFab(); }, 300);
        this.lastFocus?.focus?.({ preventScroll: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      root.querySelectorAll('.mstl').forEach((el) => {
        if (el.dataset.ready) return; el.dataset.ready = '1';
        const track = el.querySelector('.mstl__track');
        const arrows = el.querySelectorAll('.mstl__arrow');
        const update = () => {
          const max = track.scrollWidth - track.clientWidth - 2;
          arrows[0] && (arrows[0].disabled = track.scrollLeft <= 2);
          arrows[1] && (arrows[1].disabled = track.scrollLeft >= max);
        };
        arrows.forEach((a) => a.addEventListener('click', () => {
          const card = track.querySelector('.mstl__card');
          const step = card ? card.getBoundingClientRect().width + 8 : track.clientWidth;
          track.scrollBy({ left: step * Number(a.dataset.dir), behavior: 'smooth' });
        }));
        track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
        update();
        el.querySelectorAll('.mstl__bar').forEach((btn) => btn.addEventListener('click', () => {
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          const open = btn.getAttribute('aria-expanded') !== 'true';
          el.querySelectorAll('.mstl__bar[aria-expanded="true"]').forEach((other) => {
            if (other !== btn) { other.setAttribute('aria-expanded', 'false'); const p = document.getElementById(other.getAttribute('aria-controls')); if (p) p.hidden = true; }
          });
          btn.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
        }));
        el.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          const openBtn = el.querySelector('.mstl__bar[aria-expanded="true"]');
          if (openBtn) { openBtn.click(); openBtn.focus(); }
        });
        const vids = el.querySelectorAll('video');
        if (vids.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const io = new IntersectionObserver((entries) => entries.forEach((en) => {
            const v = en.target;
            if (en.isIntersecting) { v.preload = 'auto'; const pr = v.play(); if (pr) pr.catch(() => {}); } else { v.pause(); }
          }), { threshold: 0.35 });
          vids.forEach((v) => { v.muted = true; io.observe(v); });
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-social"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      root.querySelectorAll('.msoc').forEach((el) => {
        if (el.dataset.ready) return; el.dataset.ready = '1';
        const track = el.querySelector('.msoc__track');
        const bar = el.querySelector('.msoc__progress i');
        const [prev, next] = el.querySelectorAll('.msoc__arrow');
        if (!track) return;
        /* The pink thumb shows how much of the row is on screen and where you are in it */
        let raf = 0;
        const update = () => {
          raf = 0;
          const max = track.scrollWidth - track.clientWidth;
          const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          const pos = max > 0 ? track.scrollLeft / max : 0;
          if (bar) {
            const trackW = bar.parentElement.clientWidth;
            const w = Math.max(24, trackW * Math.min(1, ratio));
            bar.style.width = w + 'px';
            bar.style.transform = 'translateX(' + ((trackW - w) * pos).toFixed(1) + 'px)';
          }
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
          el.querySelector('.msoc__foot').hidden = max <= 2;
        };
        const queue = () => { if (!raf) raf = requestAnimationFrame(update); };
        track.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        const step = () => {
          const item = track.querySelector('.msoc__item');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        };
        [prev, next].forEach((b) => b && b.addEventListener('click', () => {
          track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
        }));
        update();
        el.querySelectorAll('.msoc__img').forEach((img) => { if (!img.complete) img.addEventListener('load', queue, { once: true }); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = (root) => {
      root.querySelectorAll('.mst').forEach((el) => {
        if (el.dataset.ready) return; el.dataset.ready = '1';
        const tabs = [...el.querySelectorAll('.mst__tab')];
        const panels = [...el.querySelectorAll('.mst__statement')];
        const imgs = [...el.querySelectorAll('.mst__img')];
        const bars = tabs.map((t) => t.querySelector('.mst__bar i'));
        if (!tabs.length) return;
        const dur = parseInt(el.dataset.interval, 10) || 6000;
        el.style.setProperty('--mst-dur', dur / 1000 + 's');
        let i = 0, timer, paused = false;
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const schedule = () => {
          clearTimeout(timer);
          if (paused || reduce || tabs.length < 2) return;
          /* Fallback only: the progress line's animationend is what normally advances it */
          timer = setTimeout(() => { if (!paused) go(i + 1); }, dur + 800);
        };
        const go = (n, focus) => {
          i = (n + tabs.length) % tabs.length;
          tabs.forEach((t, k) => { const on = k === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
          panels.forEach((p, k) => { p.hidden = k !== i; p.classList.toggle('is-active', k === i); });
          imgs.forEach((m, k) => { m.classList.toggle('is-active', k === i); m.setAttribute('aria-hidden', String(k !== i)); });
          if (focus) tabs[i].focus();
          schedule();
        };
        bars.forEach((b, k) => {
          if (!b) return;
          b.addEventListener('animationend', (e) => {
            if (e.animationName !== 'mstProgress' || k !== i || paused || reduce) return;
            go(i + 1);
          });
        });
        tabs.forEach((t, k) => {
          t.addEventListener('click', () => go(k));
          t.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); go(i + 1, true); }
            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1, true); }
          });
        });
        const pause = () => { paused = true; el.classList.add('is-paused'); clearTimeout(timer); };
        const resume = () => { paused = false; el.classList.remove('is-paused'); schedule(); };
        /* The line never pauses on hover or on click. The only thing that stops
           it is the section leaving the screen, so it is always moving while
           anyone is looking at it. Clicking a tab still jumps straight to it. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting) resume(); else pause(); }), { threshold: 0.3 }).observe(el);
        } else schedule();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-waitlist"]) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const run = () => {
      document.querySelectorAll('.wl__count[data-launch]').forEach((el) => {
        const target = Date.parse(el.dataset.launch);
        if (Number.isNaN(target)) { el.hidden = true; return; }
        const units = { d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'), m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]') };
        const tick = () => {
          let diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
          const d = Math.floor(diff / 86400); diff -= d * 86400;
          const h = Math.floor(diff / 3600); diff -= h * 3600;
          const m = Math.floor(diff / 60); const s = diff - m * 60;
          units.d.textContent = pad(d); units.h.textContent = pad(h); units.m.textContent = pad(m); units.s.textContent = pad(s);
        };
        tick();
        setInterval(tick, 1000);
      });
      const ok = document.getElementById('WaitlistSuccess');
      if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauja-wishlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = async () => {
      const root = document.querySelector('.mwl');
      if (!root || root.dataset.ready) return; root.dataset.ready = '1';
      const grid = root.querySelector('[data-mwl-grid]');
      const empty = root.querySelector('[data-mwl-empty]');
      const count = root.querySelector('[data-mwl-count]');
      const rmIcon = document.getElementById('MwlRemove')?.innerHTML || '×';
      const cur = root.dataset.currency || 'EGP';
      const fmt = (c) => (c / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }) + ' ' + cur;
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const get = () => (window.MaujaWishlist ? window.MaujaWishlist.get() : JSON.parse(localStorage.getItem('mauja_wishlist') || '[]'));
      const render = async () => {
        const list = get();
        count.textContent = list.length ? list.length + (list.length === 1 ? ' piece saved' : ' pieces saved') : '';
        empty.hidden = list.length > 0;
        if (!list.length) { grid.innerHTML = ''; return; }
        // 'gone' marks a product that no longer exists (404), so it is dropped from
        // the saved list and the counts; a network error keeps the item.
        const items = await Promise.all(list.map((h) => fetch('/products/' + encodeURIComponent(h) + '.js').then((r) => (r.ok ? r.json() : (r.status === 404 ? 'gone' : null))).catch(() => null)));
        const gone = list.filter((h, i) => items[i] === 'gone');
        if (gone.length) {
          const next = get().filter((h) => !gone.includes(h));
          if (window.MaujaWishlist) window.MaujaWishlist.set(next); else localStorage.setItem('mauja_wishlist', JSON.stringify(next));
          return render();
        }
        grid.innerHTML = items.filter((p) => p && p !== 'gone').map((p) => {
          const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=700' : '';
          return '<li class="mwl__card"><a class="mwl__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="875">' : '') + '</a>' +
            '<button type="button" class="mwl__rm" data-rm="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">' + rmIcon + '</button>' +
            '<div class="mwl__info"><a class="mwl__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="mwl__price">' + fmt(p.price) + '</span>' +
            '<a class="mwl__view" href="' + esc(p.url) + '">' + (p.available ? 'Shop now' : 'Sold out') + '</a></div></li>';
        }).join('');
      };
      grid.addEventListener('click', (e) => {
        const b = e.target.closest('[data-rm]'); if (!b) return;
        const next = get().filter((h) => h !== b.dataset.rm);
        if (window.MaujaWishlist) window.MaujaWishlist.set(next); else localStorage.setItem('mauja_wishlist', JSON.stringify(next));
        render();
      });
      render();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  } catch(e) { console.error(e); }
})();
})();
